/* eslint-disable no-template-curly-in-string */
import { Locale } from './locales';

export const globalTranslation = {
  [Locale.en]: {
    common: {
      space: ' ',
      colon: ':',
      to: 'to',
      of: 'of',
      from: 'from',
      ok: 'ok',
      back: 'Back',
      connect: 'Connect',
      disconnect: 'Disconnect',
      copyAccount: 'Copy Address',
      cryptoWallet: 'Crypto Wallet',
      matchIDWallet: 'MatchID',
      openMatchID: 'Open MatchID',
      connectWallet: 'Connect Wallet',
      connectMatchID: 'Connect MatchID',
      unsupportedNetwork: 'Unsupported Network',
      balance: 'Balance',
      getMore: 'Get more',
      max: 'Max',
      copy: 'Copy',
      copied: 'Copied',
      open: 'Open',
      explore: 'Explore',
      timeLeft: '{time} left',
      unlockTime: 'Unlock in {time}',
    },
    socials: {
      twitter: 'X',
      youtube: 'Youtube',
      telegram: 'Telegram',
      discord: 'Discord',
      google: 'Google',
      github: 'Github',
      linkedin: 'LinkedIn',
    },
    number: {
      compact: '{value, number, ::compact-short}',
    },
    unit: {
      $: '${value}',
      tokenValue: '{value} {token}',
      percent: '{value}%',
      tokenPerYear: '{token} / Year',
    },
    time: {
      days: '{value} {value, plural, =1 {day} other {days}}',
      hours: '{value} {value, plural, =1 {hour} other {hours}}',
      minutes: '{value} {value, plural, =1 {minute} other {minutes}}',
      seconds: '{value} {value, plural, =1 {second} other {seconds}}',
    },
    tokens: {
      main: 'MAT',
      chainToken: 'BNB',
      stakeToken: 'stMAT',
    },
    errors: {
      maxFlashPoolAmount:
        "Flash unstake amount exceeds the pool's available liquidity. Max: {value}",
    },
    validation: {
      required: 'This field is required',
      numberOnly: 'Must be a number',
      min: 'Minimum amount is {value} {unit}',
      max: 'Your balance is not sufficient',
    },
  },
};
